import React from 'react';
import { Link } from 'react-router-dom';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-[#0a0e17] text-[#f5f5f0] py-16 px-6">
      <div className="max-w-2xl mx-auto space-y-8">
        <div>
          <h1 className="text-3xl font-bold mb-1">Impressum</h1>
          <p className="text-[#8a8a8a] text-sm">Aviso Legal — Angaben gemäß § 5 TMG</p>
        </div>

        <section className="space-y-2">
          <h2 className="text-lg font-semibold text-[#d4af37]">Verantwortlich / Responsable</h2>
          <p>JOSÉ URBANEJA</p>
          <p>DRESDEN</p>
          <p>Deutschland / Alemania</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-semibold text-[#d4af37]">Kontakt / Contacto</h2>
          <p>
            E-Mail:{' '}
            <a href="mailto:soporte@wearelxi.com" className="text-[#d4af37] hover:underline">
              soporte@wearelxi.com
            </a>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-semibold text-[#d4af37]">
            Verantwortlich für den Inhalt / Responsable del contenido
          </h2>
          <p>JOSÉ URBANEJA</p>
          <p>DRESDEN, ALEMANIA</p>
        </section>

        <section className="space-y-2 text-[#8a8a8a] text-sm leading-relaxed border-t border-[#2a3444] pt-6">
          <p>
            Esta página cumple con los requisitos del § 5 de la Ley de Telemedia alemana (TMG) y el
            § 55 del Tratado Estatal de Radiodifusión (RStV).
          </p>
          <p>
            Diese Seite erfüllt die Anforderungen des § 5 Telemediengesetz (TMG) und § 55
            Rundfunkstaatsvertrag (RStV).
          </p>
        </section>

        <p className="text-[#8a8a8a] text-sm">
          <Link to="/privacidad" className="text-[#d4af37] hover:underline">
            Política de Privacidad
          </Link>{' '}
          ·{' '}
          <Link to="/cookies" className="text-[#d4af37] hover:underline">
            Política de Cookies
          </Link>
        </p>
      </div>
    </div>
  );
}
